import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const InverseZTransform = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Inverse Z-Transform"
    videos={[
      "https://www.youtube.com/embed/AbzItvOCa3Y",
      "https://www.youtube.com/embed/Gr8OwFx3sqA",
    ]}
    takeaways={[]}
    questions={[]}
    exampleVideos={[]}
  />
);
}

export default InverseZTransform;
